//packages
import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
//global components
import MainMenu from '../../_components/MainMenu';
import MainFooter from '../../_components/MainFooter';
import PreLoader from "../../_components/PreLoader";
import PageNotFound from '../../_components/PageNotFound';
//services
import { menuService } from '../../_services/menu.service';
import { postService } from '../../_services/post.service';
// //styles
// import './about.sass';

class About extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            user: {
              details: {}
            },
            menu: {},
            topbarMenu: {},
            // about: {
            //   slug: this.props.match.params[0]
            // },
            // notfound: false
            loading: true,
            branches: [],
            about: [],
            notFound: false
            
        };
    }

    componentDidMount() {
      const user = JSON.parse(localStorage.getItem('user'));
      const slug = this.props.match.params[0];
      if (user && Date.now() < user.expiresAt) {
        this.setState({ 
          user: user
        });
      }else{
        this.setState({ 
          user: {
            details: {}
          }
        });
      }
      
      Promise.allSettled([
        postService.getBySlug(slug).then( 
          about => {
            if(!about){
                this.setState({ notFound: true })
            }else{
                this.setState({ about: about[0]})
            }
         }),
        menuService.getMenuByName('default').then(menu => this.setState({ menu })),
        menuService.getMenuByName('Topbar').then(topbarMenu => this.setState({ topbarMenu })),
        postService.getBranchesFooter('branch').then(branches => this.setState({ branches }))
      ]).then(() => this.setState({ loading: false }))
    }

    render() {
        const { user, menu, topbarMenu, about, notFound, branches, loading } = this.state;
    
        return (
            <>
              <PreLoader loading={loading} />
              {!notFound ?
              <div className="page-cont>ainer">
                <MainMenu user={user} menu={menu} topbarMenu={topbarMenu}/>
                <div className="jumbotron page-title py-5">
                  <div className="container"><h1 className="text-white bolder ">{about.acf ? about.acf.title : 'About Us'}</h1></div>
                </div>
                <div className="container">
                      <div className="row">
                        <div className="col-12">
                          <nav aria-label="breadcrumb">
                            <ol className="breadcrumb bg-transparent m-0">
                              <li className="breadcrumb-item"><a href="/">Home</a></li>
                              <li className="breadcrumb-item active" aria-current="page">{about.acf ? about.acf.title : ''}</li>
                            </ol>
                          </nav>
                        </div>
                        <div className="col-12">
                          <hr className="m-0 mb-4" />
                        </div>
                      </div>
                    </div>
                {about ?
                <>
                  { about.acf ?
                  <Container>
                    <Row>
                      <Col md={3} className="image-border">
                          <Image src={about.acf.image} alt="" className="img-fluid"/>
                      </Col>
                      <Col md={9}>
                          <div dangerouslySetInnerHTML={{__html: about.content.rendered}} />
                      </Col>
                    </Row>
                  </Container>
                  :
                  <Container>
                    <Row>
                      <Col md={12}>
                          <div dangerouslySetInnerHTML={{__html: about.content}} />
                      </Col>
                    </Row>
                  </Container>
                  }
                </>
                :<center><img src="/korg_img/loader.gif" alt="loading..." /></center>
                }
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <MainFooter menu={menu} branches={branches} />

              </div>
              :
              <PageNotFound/>
              }
            </>
        );
    }
}

export { About };